// import React from 'react';

// function LoadingSpinner() {
//   return (
//     <div className="flex flex-col items-center justify-center gap-4">

//       {/* Anillos concéntricos animados */}
//       <div className="relative w-12 h-12">
//         {/* Anillo exterior — gira lento */}
//         <div
//           className="absolute inset-0 rounded-full border-2 border-transparent animate-spin"
//           style={{
//             borderTopColor: "#1c2b1e",
//             borderRightColor: "#1c2b1e",
//             animationDuration: "1s",
//           }}
//         />
//         {/* Anillo interior — gira en sentido contrario */}
//         <div
//           className="absolute inset-[6px] rounded-full border-2 border-transparent animate-spin"
//           style={{
//             borderTopColor: "#a8c5a0",
//             animationDuration: "0.7s",
//             animationDirection: "reverse",
//           }}
//         />
//         {/* Punto central */}
//         <div
//           className="absolute inset-[10px] rounded-full"
//           style={{ background: "#1c2b1e", opacity: 0.15 }}
//         />
//       </div>

//       {/* Texto */}
//       <div className="flex flex-col items-center gap-0.5">
//         <p
//           className="text-[13px] font-semibold text-[#1c2b1e]"
//           style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
//         >
//           Lorena Pets Lover
//         </p>
//         <p className="text-[11px] text-gray-400 tracking-widest uppercase">
//           cargando...
//         </p>
//       </div>

//     </div>
//   );
// }

// export default LoadingSpinner;

import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center gap-4">

      {/* Anillos concéntricos animados */}
      <div className="relative w-14 h-14">
        {/* Anillo exterior */}
        <div
          className="absolute inset-0 rounded-full border-[3px] border-transparent animate-spin"
          style={{
            borderTopColor: "#0f4a4e",
            borderRightColor: "#0f4a4e",
            animationDuration: "1s",
          }}
        />
        {/* Anillo interior — sentido contrario */}
        <div
          className="absolute inset-[7px] rounded-full border-[3px] border-transparent animate-spin"
          style={{
            borderTopColor: "#f5853f",
            animationDuration: "0.7s",
            animationDirection: "reverse",
          }}
        />
        {/* Huella central con latido */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            className="w-5 h-5 text-[#0f4a4e] animate-pulse"
            viewBox="0 0 64 64"
            fill="currentColor"
          >
            <ellipse cx="20" cy="16" rx="7" ry="9" />
            <ellipse cx="44" cy="16" rx="7" ry="9" />
            <ellipse cx="9" cy="33" rx="6" ry="8" />
            <ellipse cx="55" cy="33" rx="6" ry="8" />
            <path d="M32 28c-9 0-17 7-17 16 0 7 5 11 12 11 3 0 4-1 5-1s2 1 5 1c7 0 12-4 12-11 0-9-8-16-17-16Z" />
          </svg>
        </div>
      </div>

      {/* Texto */}
      <div className="flex flex-col items-center gap-0.5">
        <p
          className="text-[14px] font-bold text-[#0f4a4e]"
          style={{ fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}
        >
          Lorena Pets Lover
        </p>
        <p className="text-[11px] text-gray-400 tracking-widest uppercase">
          cargando productos...
        </p>
      </div>

    </div>
  );
}

export default LoadingSpinner;